<template>
  <div>
    <Heading class="wealth-summary__title" :level="3">Resumo</Heading>
    <Row
      v-if="!hideIncomeStory"
      has-interaction
      has-line
      chevron
      @click="goToIncomeHistory"
    >
      <template #icon-left>
        <InitialAvatarIcon
          icon="BB0050"
          size="medium"
          class="wealth-summary__icon"
        />
      </template>
      <template #top-left>Performance</template>
    </Row>
    <Row has-interaction has-line chevron @click="allocationClick">
      <template #icon-left>
        <InitialAvatarIcon
          icon="BB0020"
          size="medium"
          class="wealth-summary__icon"
        />
      </template>
      <template #top-left>Alocação</template>
    </Row>
    <Row
      v-if="showConfig"
      has-interaction
      has-line
      chevron
      @click="toggleConfig"
    >
      <template #icon-left>
        <InitialAvatarIcon
          icon="EE0160"
          size="medium"
          class="wealth-summary__icon"
        />
      </template>
      <template #top-left>Configurações</template>
    </Row>
    <WealthConfig
      v-if="portfolio"
      :is-open="isConfigOpen"
      :portfolio="portfolio"
      @close-config="toggleConfig"
      @save="emitSave"
    />
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import {
  Heading,
  Row,
  BaseIcon,
  InitialAvatarIcon
} from '@warrenbrasil/nebraska-web';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import { WealthConfig } from './components/WealthConfig';
import { trackViewHistoricalBalance } from './track-events';
import { IWealthPortfolio } from '@/modules/wealth/services/investment/investment-types';

@Component({
  components: { Heading, Row, BaseIcon, WealthConfig, InitialAvatarIcon }
})
export default class WealthSummary extends Vue {
  readonly NebraskaColors = NebraskaColors;

  @Prop({ type: Object, required: false })
  readonly portfolio?: IWealthPortfolio;

  @Prop({ type: Boolean, default: false })
  readonly hideIncomeStory!: boolean;

  @Prop({ type: Boolean, default: true })
  readonly showConfig!: boolean;

  @Emit('set-panel')
  private emitSetPanel() {}

  @Emit('tracking')
  private emitTracking() {}

  @Emit('save')
  emitSave() {}

  isConfigOpen = false;

  allocationClick() {
    this.emitTracking();
    this.emitSetPanel();
  }

  pushWealthIncomeHistory(query?: { portfolio: string }) {
    this.$router.push({
      name: 'wealthPerformance',
      query
    });

    trackViewHistoricalBalance();
  }

  goToIncomeHistory() {
    if (this.portfolio) {
      const query = { portfolio: this.portfolio.id };
      this.pushWealthIncomeHistory(query);
      return;
    }
    this.pushWealthIncomeHistory();
  }

  toggleConfig() {
    this.isConfigOpen = !this.isConfigOpen;
  }
}
</script>

<style lang="less" scoped>
.wealth-summary {
  &__title {
    margin-bottom: @size-spacing-x400;
  }

  &__icon {
    color: @element-primary;
    background: @background-tertiary;
  }
}
</style>
